import React from 'react';
import { Progress } from './ui/progress';
import { Check } from 'lucide-react';

const defaultSteps = [
  { id: 0, label: 'Datos' },
  { id: 1, label: 'Preguntas' },
  { id: 2, label: 'Cuadraditos' },
  { id: 3, label: 'Contexto' },
  { id: 4, label: 'Rueda' },
  { id: 5, label: 'Reflexión' },
  { id: 6, label: 'Objetivos' },
  { id: 7, label: 'Cierre' },
  { id: 8, label: 'Resumen' },
];

export function WizardProgress({ currentStep, onStepClick, steps = defaultSteps }) {
  const progressPercentage = ((currentStep + 1) / steps.length) * 100;

  return (
    <div className="w-full space-y-4">
      <Progress value={progressPercentage} className="h-2" />
      
      <div className="hidden sm:flex justify-between">
        {steps.map((step) => (
          <button
            key={step.id}
            onClick={() => onStepClick && step.id <= currentStep && onStepClick(step.id)}
            disabled={step.id > currentStep}
            className={`flex flex-col items-center gap-1 text-xs transition-colors ${
              step.id === currentStep
                ? 'text-primary font-semibold'
                : step.id < currentStep
                ? 'text-primary/70 cursor-pointer hover:text-primary'
                : 'text-muted-foreground'
            }`}
            data-testid={`wizard-step-${step.id}`}
          >
            <div
              className={`w-8 h-8 rounded-full flex items-center justify-center border-2 transition-colors ${
                step.id === currentStep
                  ? 'border-primary bg-primary text-white'
                  : step.id < currentStep
                  ? 'border-primary bg-primary/10 text-primary'
                  : 'border-muted-foreground/30 bg-transparent'
              }`}
            >
              {step.id < currentStep ? (
                <Check className="w-4 h-4" />
              ) : (
                step.id + 1
              )}
            </div>
            <span className="hidden md:block">{step.label}</span>
          </button>
        ))}
      </div>

      <div className="sm:hidden text-center">
        <span className="text-sm font-medium text-primary">
          Paso {currentStep + 1} de {steps.length}: {steps[currentStep]?.label}
        </span>
      </div>
    </div>
  );
}

export default WizardProgress;
